import { TrackingManager } from '@benzinga/tracking-manager';
import styled from '@benzinga/themetron';
import { Microsoft, AppleBlack, Google } from '@benzinga/icons';
import React from 'react';
import { SessionContext } from '@benzinga/session-context';

const AuthButtonStyled = styled.button`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border: 0.5px solid ${({ theme }) => theme.colorPalette.gray100};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  background: #f2f8ff;
  color: #000000;
  text-transform: unset;
  text-align: right;
  font-weight: 700;
  width: 100%;
  height: 50px;
  padding: 1.5rem 1rem;
  gap: 16px;

  @media (max-width: 768px), (max-height: 800px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px 4px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colorPalette.gray50};
    box-shadow: ${({ theme }) => theme.shadow.default};
  }

  &:active {
    background-color: ${({ theme }) => theme.colorPalette.blue100};
  }

  svg {
    width: 28px;
    height: 28px;
  }
`;

const getSocialPath = (provider: string): string => {
  let authPath;
  switch (provider) {
    case 'apple':
      authPath = 'apple-id';
      break;
    case 'google':
      authPath = 'google-oauth2';
      break;
    case 'microsoft':
      authPath = 'microsoft-graph';
      break;
  }
  return authPath;
};

export default ({
  nextUrl,
  onSocialClicked,
  socialType,
}: {
  nextUrl?: string;
  onSocialClicked?: (socialPath: string, forceUrl?: string) => void;
  socialType: string;
}) => {
  const session = React.useContext(SessionContext);
  const socialClicked = () => {
    session.getManager(TrackingManager).trackLinkEvent('click', {
      link_action: 'onSocialClicked',
      link_id: socialType,
      link_type: 'social',
      link_url: nextUrl,
    });
    const authPath = getSocialPath(socialType);
    if (onSocialClicked) {
      onSocialClicked(authPath, nextUrl);
    }
  };

  return (
    <AuthButtonStyled
      className="select-none"
      onClick={() => {
        socialClicked();
      }}
    >
      {socialType === 'google' && (
        <>
          <Google />
          <span className="hidden xl:inline">Google</span>
        </>
      )}
      {socialType === 'apple' && (
        <>
          <AppleBlack className="apple" />
          <span className="hidden xl:inline">Apple</span>
        </>
      )}
      {socialType === 'microsoft' && (
        <>
          <Microsoft />
          <span className="hidden xl:inline">Microsoft</span>
        </>
      )}
    </AuthButtonStyled>
  );
};
